export default "__VITE_ASSET__fde314f2__"